import React, { useEffect } from 'react'

import classes from './Register.module.css'
import EmployeeImage from '../../assets/Employee.png'
import EmployerImage from '../../assets/Employer.jpg'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import {NavText} from "../../components/NavElements";

import logo from "../../assets/logo.png";
interface Props {

}

export const Register: React.FC<Props> = () => {
    const { pathname } = useLocation()
    useEffect(()=>{
        window.scrollTo(0, 0)
    },[pathname])
    return (
        <React.Fragment>
        {/*<Header />*/}
        <div className={classes.container +"  p-0 m-0"}>


        <div className={classes.darker +"  p-0 m-0"}>
            <div className={'d-flex justify-content-center'}>
                <NavText to='/'>   <img className={classes.logo} src={logo} alt='Logo' /> </NavText>
            </div>
            <h1 className={classes.head}>التسجيل</h1>
            <div className={classes.choose}>
                <Link className={classes.card + '  my-2'} to='/register/employer'>
                    <img alt='Employee' src={EmployerImage} className={classes.image} />
                   <p>صاحب عمل / باحث عن موظفين</p>
                </Link>
                <Link className={classes.card + '  my-2'} to='/register/employee'>
                    <img alt='Employee' src={EmployeeImage} className={classes.image} />
                   <p>موظف / باحث عن عمل</p>
                </Link>
            </div>
        </div>
        </div>
        </React.Fragment>
    )
}